import styled from 'styled-components';

import {
  colorBlack900,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
  mediaQueryMobileMin,
} from '@/styleUtils';

export const ListHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  z-index: 1;
  gap: 12px;

  @media ${mediaQueryMobileMin} {
    padding: 0;
  }

  @media ${mediaQueryMobileLargeMin} {
    align-items: baseline;
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const TextCount = styled.p`
  width: 100%;
  font: normal 700 18px/24px ${fontFamilySecondary};
  color: ${colorBlack900};
`;
